export default __webpack_public_path__ + "static/media/Background_00277.0abd33db.png";